import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";

import OBAPageIntroComponent from "../components/common/OBAPageIntroComponent";
import SchoolHistoryComponent from "../components/oba/SchoolHistoryComponent";
import OBAHistoryComponent from "../components/oba/OBAHistoryComponent";
import PastExecutiveCommitteesComponent from "../components/oba/PastExecutiveCommitteesComponent";
import PaginationComponent from "../components/common/PaginationComponent";

import logo from "../assests/oba_logo_nbg.png";

import pastExecutiveCommitteesData from "../data/pastCommittees.json";

export default function OldBoysAssociationHistoryPage() {
  const location = useLocation();

  const [pageNumber, setPageNumber] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.substring(1));
      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const totalPages = Math.ceil(
    pastExecutiveCommitteesData.length / itemsPerPage,
  );

  const startIndex = (pageNumber - 1) * itemsPerPage;

  const currentCommittees = pastExecutiveCommitteesData.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const hasNextPage = pageNumber < totalPages;
  const hasPreviousPage = pageNumber > 1;

  useEffect(() => {
    if (pageNumber > totalPages) {
      setPageNumber(1);
    }
  }, [totalPages, pageNumber]);

  return (
    <div
      className="d-flex flex-column min-vh-100 overflow-x-hidden"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <HeaderComponent user={null} />

      <main className="flex-grow-1 py-5">
        <div className="container px-3">
          {/* Hero Section */}
          <OBAPageIntroComponent
            image={logo}
            title="Old Boys' Association of Vidyaloka College"
            description="Connecting past, present, and future generations of Vidyalokians.
              Our association fosters a strong community among former students
              and actively supports the development of Vidyaloka College in
              Galle, Sri Lanka."
          />

          {/* School History Section */}
          <SchoolHistoryComponent />

          {/* OBA History Section */}
          <OBAHistoryComponent />

          {/* Paginated Committees */}
          <PastExecutiveCommitteesComponent
            pastCommittees={currentCommittees}
          />

          {/* Your Pagination Component */}
          <PaginationComponent
            pageNumber={pageNumber}
            totalPages={totalPages}
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            onPageChange={setPageNumber}
            scrollToTop={false}
          />
        </div>
      </main>

      <FooterComponent />
    </div>
  );
}
